import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OperadorService } from '../services/operador.service';

@Component({
  selector: 'app-access-register',
  templateUrl: './access-register.component.html',
  styleUrls: ['./access-register.component.scss'],
})
export class AccessRegisterComponent implements OnInit {
  constructor(
    private _operadorService: OperadorService,
    private _router: Router,
    private _route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this._route.queryParams.subscribe((data) => {
      if (data['token'] !== undefined) {
        //
        this._operadorService.setOperadorLoggedIn(
          {
            access_token: data['token'],
            operador: null,
          },
          true
        );

        this._operadorService.profile().subscribe((data) => {

          localStorage.removeItem('welcome_steps_complete');
          localStorage.removeItem('welcome_steps');

          this._router.navigate(['app/bem-vindo']);
        });
      } else {
        this._router.navigate(['/acessar']);
      }
    });
  }
}
